import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
// import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Login from "./reducers/authReducer"
import Alert from "./reducers/alertReducer"
// import Bookings from "./reducers/bookingReducer"
import JobApplication from "./reducers/jobApplicationReducer"
import Interviews from "./reducers/interviewsReducer.js"
import Common from "./reducers/commonReducer"
import TheoreticalTraining from "./reducers/theoreticalTrainingReducer"
import PracticalTraining from "./reducers/practicalTrainingReducer"
import Users from "./reducers/userReducer"
import Dashboard from "./reducers/dashboardReducer"
import RolesAndPermissions from "./reducers/roleReducer"
import TrainingMaterials from "./reducers/trainingMaterialReducer"
import ExportOption from "./reducers/exportOptionReducer"
import TrialPeriods from "./reducers/trialPeriodReducer"
import Catering from "./reducers/cateringReducer"
import Card from "./reducers/cardReducer"
import Contract from "./reducers/contractReducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Alert,
  Login,
  Account,
  ForgetPassword,
  Profile,
  // Bookings,
  JobApplication,
  Interviews,
  Common,
  TheoreticalTraining,
  PracticalTraining,
  Users,
  Dashboard,
  RolesAndPermissions,
  TrainingMaterials,
  ExportOption,
  TrialPeriods,
  Catering,
  Card,
  Contract,
})

export default rootReducer
